
export default function Reviews() {
  const reviews = [
    {
      name: 'Sarah M.',
      role: 'Verified Buyer',
      rating: 5,
      text: 'I was skeptical at first, but after 3 weeks of consistent use, I can definitely see a difference. My jawline looks more defined and I wake up feeling more rested. Worth every penny.',
      image: 'https://public.readdy.ai/ai/img_res/638f2dcfc75617b791778010abf32697.jpg'
    },
    {
      name: 'Michael T.',
      role: 'Verified Buyer',
      rating: 5,
      text: 'Comfortable to wear all night. I used to snore a lot, but my partner says it\'s significantly reduced. The quality is excellent and it\'s easy to adjust.',
      image: 'https://readdy.ai/api/search-image?query=professional-man-portrait-confident-expression-strong-jawline-natural-lighting-clear-skin-studio-photography-minimalist-background-wellness-lifestyle&width=400&height=400&seq=review-michael-002&orientation=squarish'
    },
    {
      name: 'Emma L.',
      role: 'Verified Buyer',
      rating: 5,
      text: 'Best purchase I\'ve made for my sleep routine. It took a few nights to get used to, but now I can\'t sleep without it. My face looks more sculpted and I breathe better.',
      image: 'https://readdy.ai/api/search-image?query=young-woman-portrait-healthy-lifestyle-natural-beauty-radiant-skin-confident-smile-studio-lighting-minimalist-aesthetic-wellness-modern-photography&width=400&height=400&seq=review-emma-003&orientation=squarish'
    }
  ];

  return (
    <section className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-20 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20 max-w-3xl mx-auto">
          <div className="text-[10px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-[0.15em] text-[#8A8A8A] mb-4 sm:mb-6">
            TESTIMONIALS
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black leading-tight mb-4 sm:mb-6 px-4">
            Trusted by Thousands
          </h2>
          <p className="text-sm sm:text-base text-[#6B6B6B] leading-relaxed px-4">
            Real results from real people who committed to the process.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {reviews.map((review, index) => (
            <div key={index} className="bg-[#FAFAFA] p-6 sm:p-8 rounded-2xl">
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4 sm:mb-6">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-base sm:text-lg text-black"></i>
                ))}
              </div>
              
              {/* Review Text */}
              <p className="text-sm sm:text-base text-[#6B6B6B] leading-relaxed mb-6 sm:mb-8">
                "{review.text}"
              </p>
              
              {/* Reviewer Info */}
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden bg-black/5 flex-shrink-0">
                  <img 
                    src={review.image} 
                    alt={review.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm sm:text-base font-semibold text-black">{review.name}</p>
                  <p className="text-xs sm:text-sm text-[#8A8A8A]">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mt-12 sm:mt-16 lg:mt-20 pt-12 sm:pt-16 border-t border-black/10">
          <div className="text-center">
            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black mb-2">10,000+</p>
            <p className="text-xs sm:text-sm text-[#6B6B6B]">Happy Customers</p>
          </div>
          <div className="text-center">
            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black mb-2">4.9</p>
            <p className="text-xs sm:text-sm text-[#6B6B6B]">Average Rating</p>
          </div>
          <div className="text-center">
            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black mb-2">98%</p>
            <p className="text-xs sm:text-sm text-[#6B6B6B]">Would Recommend</p>
          </div>
          <div className="text-center">
            <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black mb-2">24h</p>
            <p className="text-xs sm:text-sm text-[#6B6B6B]">Fast Shipping</p>
          </div>
        </div>
      </div>
    </section>
  );
}
